import axios from '../lib/axios';
import { ApiKey, CreateApiKeyDto, UpdateApiKeyDto } from '../types/apiKey';

export const apiKeyService = {
  getApiKeys: async (): Promise<ApiKey[]> => {
    const { data } = await axios.get('/api-keys');
    return data;
  },

  createApiKey: async (dto: CreateApiKeyDto): Promise<ApiKey> => {
    const { data } = await axios.post('/api-keys', dto);
    return data;
  },

  updateApiKey: async (key: string, dto: UpdateApiKeyDto): Promise<ApiKey> => {
    const { data } = await axios.put(`/api-keys/${key}`, dto);
    return data;
  },

  deleteApiKey: async (key: string): Promise<void> => {
    await axios.delete(`/api-keys/${key}`);
  },
}; 